if (!customElements.get('sl-ritual-steps')) {
  class SlRitualSteps extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ritual-steps__track');
      this.lineFill = this.querySelector('[data-ritual-line-fill]');
      this.nodes = Array.from(this.querySelectorAll('[data-ritual-node]'));
      if (!this.track || !this.lineFill || !this.nodes.length) return;

      this.triggerRatio = (parseFloat(this.dataset.triggerPosition) || 70) / 100;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const triggerY = window.innerHeight * this.triggerRatio;
      const trackRect = this.track.getBoundingClientRect();

      if (trackRect.height > 0) {
        let progress = (triggerY - trackRect.top) / trackRect.height;
        progress = Math.max(0, Math.min(1, progress));
        this.lineFill.style.height = (this.reducedMotion ? Math.round(progress) * 100 : progress * 100) + '%';
      }

      this.nodes.forEach((node) => {
        const isActive = node.getBoundingClientRect().top <= triggerY;
        node.classList.toggle('is-active', isActive);
      });
    }
  }

  customElements.define('sl-ritual-steps', SlRitualSteps);
}